module.exports = __webpack_public_path__ + "img/a081.19c55e0b.png";